import React from 'react';
import { getAircraftTypes, getShowFiltersHideSearch } from '../../redux/selectors/flyingPage';
import { useSelector } from 'react-redux';
import { Col, Row } from 'antd';
import FlightOrgFilter from './FlightOrgFilter';
import FlightAircraftTypeFilter from './FlightAircraftTypeFilter';
import FlightFilterTextBox from './FlightFilterTextBox';
import FlightFilterButton from './FlightFilterButton';
import { getUserOrgData } from '../../redux/selectors/userData';

const FlightFilterAndSearchContainer: React.FC = () => {
  const showFiltersHideSearch = useSelector(getShowFiltersHideSearch);
  const userOrgs = useSelector(getUserOrgData);
  const aircraftTypes = useSelector(getAircraftTypes);
  if (userOrgs === undefined || aircraftTypes === undefined) {
    return <></>;
  }

  if (userOrgs.length > 1 && aircraftTypes.length > 1) {
    // both filters
    return (
      <Row>
        <div hidden={!showFiltersHideSearch}>
          <Col span={11}>
            <FlightOrgFilter />
          </Col>
          <Col span={9}>
            <FlightAircraftTypeFilter />
          </Col>
        </div>
        <div hidden={showFiltersHideSearch}>
          <Col span={20}>
            <FlightFilterTextBox />
          </Col>
        </div>
        <Col span={4}>
          <FlightFilterButton />
        </Col>
      </Row>
    );
  } else if (userOrgs.length > 1 && aircraftTypes.length <= 1) {
    // only org filter
    return (
      <Row>
        <div hidden={!showFiltersHideSearch}>
          <Col span={20}>
            <FlightOrgFilter />
          </Col>
        </div>
        <div hidden={showFiltersHideSearch}>
          <Col span={20}>
            <FlightFilterTextBox />
          </Col>
        </div>
        <Col span={4}>
          <FlightFilterButton />
        </Col>
      </Row>
    );
  } else if (userOrgs.length <= 1 && aircraftTypes.length > 1) {
    // only aircraft type filter
    return (
      <Row>
        <div hidden={!showFiltersHideSearch}>
          <Col span={20}>
            <FlightAircraftTypeFilter />
          </Col>
        </div>
        <div hidden={showFiltersHideSearch}>
          <Col span={20}>
            <FlightFilterTextBox />
          </Col>
        </div>
        <Col span={4}>
          <FlightFilterButton />
        </Col>
      </Row>
    );
  }
  // only search
  return (
    <Row>
      <Col>
        <FlightFilterTextBox />
      </Col>
    </Row>
  );
};

export default FlightFilterAndSearchContainer;
